// extracted by mini-css-extract-plugin
var _1 = "ApplicantDocumentRejectModalFields-moduleApplicantDocumentRejectModalFields__z2IPr";
export { _1 as "ApplicantDocumentRejectModalFields" }
